"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_select_1 = __importDefault(require("react-select"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var NoSsr_1 = __importDefault(require("@material-ui/core/NoSsr"));
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var Paper_1 = __importDefault(require("@material-ui/core/Paper"));
var Chip_1 = __importDefault(require("@material-ui/core/Chip"));
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var Cancel_1 = __importDefault(require("@material-ui/icons/Cancel"));
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: {
            flexGrow: 1,
        },
        input: {
            display: "flex",
            padding: 10,
            height: "auto",
        },
        valueContainer: {
            display: "flex",
            flexWrap: "wrap",
            flex: 1,
            alignItems: "center",
            overflow: "hidden",
        },
        chip: {
            margin: theme.spacing(0.5, 0.25),
        },
        chipFocused: {
            backgroundColor: (0, styles_1.emphasize)(theme.palette.type === "light"
                ? theme.palette.grey[300]
                : theme.palette.grey[700], 0.08),
        },
        noOptionsMessage: {
            padding: theme.spacing(1, 2),
        },
        singleValue: {
            fontSize: 16,
        },
        placeholder: {
            left: 2,
            bottom: 6,
            fontSize: 16,
        },
        paper: {
            position: "absolute",
            zIndex: 1000,
            marginTop: theme.spacing(1),
            left: 0,
            right: 0,
        },
        divider: {
            height: theme.spacing(2),
        },
        helperText: {
            color: "rgba(0,0,0,0.54)",
            fontSize: "0.75rem",
            fontWeight: 400,
            marginTop: 3,
            marginLeft: 14,
        },
    });
});
function NoOptionsMessage(props) {
    return (react_1.default.createElement(Typography_1.default, __assign({ color: "textSecondary", className: props.selectProps.classes.noOptionsMessage }, props.innerProps), "Sem resultados"));
}
function inputComponent(_a) {
    var inputRef = _a.inputRef, props = __rest(_a, ["inputRef"]);
    return react_1.default.createElement("div", __assign({ ref: inputRef }, props));
}
function Control(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, _a = props.selectProps, classes = _a.classes, TextFieldProps = _a.TextFieldProps;
    return (react_1.default.createElement(TextField_1.default, __assign({ fullWidth: true, variant: "outlined", InputProps: {
            inputComponent: inputComponent,
            inputProps: __assign({ className: classes.input, ref: innerRef, children: children }, innerProps),
        } }, TextFieldProps)));
}
function Option(props) {
    return (react_1.default.createElement(MenuItem_1.default, __assign({ ref: props.innerRef, selected: props.isFocused, component: "div", style: {
            fontWeight: props.isSelected ? 500 : 400,
        } }, props.innerProps), props.children));
}
function Placeholder(props) {
    var selectProps = props.selectProps, _a = props.innerProps, innerProps = _a === void 0 ? {} : _a, children = props.children;
    return (react_1.default.createElement(Typography_1.default, __assign({ color: "textSecondary", className: selectProps.classes.placeholder }, innerProps), children));
}
function SingleValue(props) {
    return (react_1.default.createElement(Typography_1.default, __assign({ className: props.selectProps.classes.singleValue }, props.innerProps), props.children));
}
function ValueContainer(props) {
    return (react_1.default.createElement("div", { className: props.selectProps.classes.valueContainer }, props.children));
}
var MoreSelectedBadge = function (_a) {
    var items = _a.items;
    var style = {
        marginLeft: "auto",
        background: "#a6193c",
        borderRadius: "10px",
        fontSize: "11px",
        padding: "5px",
        order: 99,
        color: "#fff",
    };
    var title = items.join(", ");
    var length = items.length;
    var label = "+ ".concat(length, " iten").concat(length !== 1 ? "s" : "", " selecionados");
    return (react_1.default.createElement("div", { style: style, title: title }, label));
};
function MultiValue(_a) {
    var _b;
    var index = _a.index, getValue = _a.getValue, props = __rest(_a, ["index", "getValue"]);
    var maxToShow = 11;
    var overflow = getValue()
        .slice(maxToShow)
        .map(function (x) { return x.label; });
    return index < maxToShow ? (react_1.default.createElement(Chip_1.default, { tabIndex: -1, label: props.children, className: (0, clsx_1.default)(props.selectProps.classes.chip, (_b = {},
            _b[props.selectProps.classes.chipFocused] = props.isFocused,
            _b)), onDelete: props.removeProps.onClick, deleteIcon: react_1.default.createElement(Cancel_1.default, __assign({}, props.removeProps)) })) : index === maxToShow ? (react_1.default.createElement(MoreSelectedBadge, { items: overflow })) : null;
}
function Menu(props) {
    return (react_1.default.createElement(Paper_1.default, __assign({ square: true, className: props.selectProps.classes.paper }, props.innerProps), props.children));
}
var components = {
    Control: Control,
    Menu: Menu,
    MultiValue: MultiValue,
    NoOptionsMessage: NoOptionsMessage,
    Option: Option,
    Placeholder: Placeholder,
    SingleValue: SingleValue,
    ValueContainer: ValueContainer,
};
function AutoComplete(props) {
    var classes = useStyles();
    var theme = (0, styles_1.useTheme)();
    var isHelperTextEnabled = props.enableHelperText !== undefined ? props.enableHelperText : false;
    var selectStyles = {
        input: function (base) { return (__assign(__assign({}, base), { color: theme.palette.text.primary, "& input": {
                font: "inherit",
            } })); },
    };
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(NoSsr_1.default, null,
            react_1.default.createElement(react_select_1.default, { classes: classes, styles: selectStyles, inputId: props.id, TextFieldProps: {
                    label: props.label,
                    InputLabelProps: {
                        htmlFor: props.id,
                        shrink: true,
                    },
                }, placeholder: props.placeholder, options: props.options, components: components, value: props.value, onChange: props.onChange, isMulti: props.multiple, filterOption: props.filterFunction, backspaceRemovesValue: true, isClearable: true, isDisabled: props.isDisabled }),
            isHelperTextEnabled && (react_1.default.createElement(Typography_1.default, { className: classes.helperText }, props.helperText)),
            react_1.default.createElement("div", { className: classes.divider }))));
}
exports.default = AutoComplete;
//# sourceMappingURL=AutoComplete.js.map